import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { ManualDataRefetchCountHandle } from '../../types';
import { ChartErrorDisplay } from '../errors/components/ChartErrorDisplay';

interface ChartErrorBoundaryProps {
  children: React.ReactNode;
  manualDataRefetchCountHandle: ManualDataRefetchCountHandle;
}

export const ChartErrorBoundary = (props: ChartErrorBoundaryProps) => {
  const { manualDataRefetchCountHandle, children } = props;
  return (
    <ErrorBoundary
      fallback={(errorData) => (
        <ChartErrorDisplay
          error={errorData.error as Error}
          retry={() => {
            errorData?.resetError();
            manualDataRefetchCountHandle.increment();
          }}
        />
      )}
    >
      {children}
    </ErrorBoundary>
  );
};
